import React from 'react';
import { Grid } from '@material-ui/core';

import { InstructionSmallImage } from './styles';

type Props = {
  text: string;
  imageUrl: string;
};

const SmallImageItem = ({ text, imageUrl }: Props) => {
  const classes = InstructionSmallImage();

  return (
    <Grid container alignItems="center" className={classes.root}>
      <Grid container item className={classes.smallImageWrapper} alignItems="center" data-small-image>
        <img src={imageUrl} className={classes.smallImage} alt="" />
      </Grid>
      <Grid item className={classes.textWrapper}>
        {text}
      </Grid>
    </Grid>
  );
};

export default SmallImageItem;
